import * as React from 'react';
import { Form } from 'formik';

import { IEditForm } from '../types';
import { FormInput, Button, FormCheckbox } from 'src/components';

const EditForm = ({
  id,
  error,
  errors,
  isSubmitting,
  children,
  isValid,
  dirty,
}: IEditForm) => (
  <div className="pt-5 px-6 mx-px">
    <Form autoComplete="off">
      {children}
      <div className="flex">
        <div className="flex-1 mr-8">
          <div className="flex mb-6">
            <label className="w-32 pt-2 pr-6" htmlFor={`name-${id}`}>
              Name*
            </label>
            <div className="flex-1">
              <FormInput className="w-full" name={`name-${id}`} />
            </div>
          </div>
          <div className="flex mb-6">
            <label className="w-32 pt-1 pr-6" htmlFor={`active-${id}`}>
              Active
            </label>
            <div className="flex-1">
              <FormCheckbox className="w-full" name={`active-${id}`} />
            </div>
          </div>
        </div>
        <div className="flex-1">
          <div className="flex mb-6">
            <label
              className="w-48 pt-2 pr-6"
              htmlFor={`shortDomainWhitelisted-${id}`}
            >
              Shortener whitelist
            </label>
            <div className="flex-1">
              <FormInput
                className="w-full"
                name={`shortDomainWhitelisted-${id}`}
              />
            </div>
          </div>
          <div className="flex mb-6">
            <label
              className="w-48 pt-2 pr-6"
              htmlFor={`shortDomainNonWhitelisted-${id}`}
            >
              Shortener blacklist
            </label>
            <div className="flex-1">
              <FormInput
                className="w-full"
                name={`shortDomainNonWhitelisted-${id}`}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center pt-4 pb-5 bg-grey-transparent sticky pin-b pin-r">
        <div className="flex-1 text-red">
          {error && error + ' '}
          {Object.values(errors).join(', ')}
        </div>
        <Button
          type="submit"
          background="grey"
          loading={isSubmitting}
          loadingLabel="Saving"
          disabled={!dirty || !isValid}
        >
          Save
        </Button>
      </div>
    </Form>
  </div>
);

export default EditForm;



// WEBPACK FOOTER //
// ./src/views/Admin/Profiles/components/EditForm.tsx